import { useState } from 'react';

import useFetchAllContactUsMessages from './hooks/useFetchAllContactUsMessages';
import ContactUsMessagesTable from './ContactUsMessagesTable';
import CreateHeader from '@components/layout/createHeader/CreateHeader';
import Title from 'lib/src/components/typography/Title';
import DeleteContactUsMessageModal from './DeleteContactUsMessageModal';
import Breadcrumb from '@components/breadcrumb/Breadcrumb';
import DataCheck from 'lib/src/components/common/DataCheck';
import { isEmpty } from 'lib/src/utils/generic';
import { contactUsMessagesBreadcrumb } from '../../../constants/breadcrumbItems';

const ContactUsMessages: React.FC = () => {
    const { contactUsMessages, isFetching, fetchError } = useFetchAllContactUsMessages();

    const [messageToDelete, setMessageToDelete] = useState<number | null>(null);

    return (
        <>
            <Breadcrumb items={contactUsMessagesBreadcrumb} />
            <CreateHeader>
                <Title>Contact Us Messages</Title>
            </CreateHeader>

            <DataCheck
                isFetching={false}
                dataExists={!isEmpty(contactUsMessages)}
                error={fetchError}
            >
                <ContactUsMessagesTable
                    contactUsMessages={Object.values(contactUsMessages)}
                    isFetching={isFetching}
                    setMessageToDelete={setMessageToDelete}
                />
            </DataCheck>
            {!!messageToDelete && (
                <DeleteContactUsMessageModal
                    message={contactUsMessages[messageToDelete]}
                    closeModal={() => setMessageToDelete(null)}
                />
            )}
        </>
    );
};

export default ContactUsMessages;
